import React, { useEffect, useState } from "react";
import { Container, Card, CardBody, Table, Spinner } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import footerBg from "./../../assets/footerbg.jpg";
import BaseUrl from "../../base-api";
import AxiosInstance from "../Utility/AxiosInstance";
import { handleAxiosError } from "../Utility/handleAxiosError";

const CapfRegistrationDistrictCounts = () => {
  const [districts, setDistricts] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCounts = async () => {
      setLoading(true);
      try {
        const res = await AxiosInstance.get(
          `${BaseUrl}/api/public/capf/district-counts`
        );
        if (res.data.status === 200 && res.data.data) {
          setDistricts(res.data.data.districts || []);
          setTotal(res.data.data.total || 0);
        }
      } catch (error) {
        handleAxiosError(error);
      } finally {
        setLoading(false);
      }
    };

    fetchCounts();
  }, []);

  return (
    <>
      <div
        style={{
          backgroundImage: `url(${footerBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          padding: "30px 0",
          color: "white",
          margin: "2%",
          borderRadius: "10px",
        }}
      >
        <Container>
          <h3 className="fw-bold mb-0 text-center">
            <FontAwesomeIcon icon={faStar} className="me-2" />
            CAPF Registration — District-wise Count
          </h3>
        </Container>
      </div>

      <Container className="py-5">
        <Card
          className="border-0 mb-5"
          style={{
            borderRadius: "20px",
            overflow: "hidden",
            boxShadow: "0 12px 40px rgba(30,60,114,0.15)",
          }}
        >
          <div
            style={{
              background: "linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)",
              padding: "25px",
              color: "white",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: "10px",
            }}
          >
            <h4 className="fw-bold mb-0">
              <FontAwesomeIcon icon={faStar} className="me-2" />
              Live District-wise CAPF Registrations
            </h4>
            <span
              style={{
                background: "rgba(255,255,255,0.2)",
                padding: "8px 16px",
                borderRadius: "20px",
                fontWeight: 600,
              }}
            >
              Total: {total}
            </span>
          </div>
          <CardBody className="p-4">
            {loading ? (
              <div className="text-center py-5">
                <Spinner color="primary" />
                <p className="mt-3 mb-0" style={{ color: "#1e3c72" }}>
                  Loading live district counts...
                </p>
              </div>
            ) : districts.length === 0 ? (
              <div className="text-center py-4" style={{ color: "#6c757d" }}>
                <FontAwesomeIcon icon={faInfoCircle} className="me-2" />
                No district data available.
              </div>
            ) : (
              <div className="table-responsive">
                <Table bordered hover className="mb-0">
                  <thead>
                    <tr>
                      <th
                        style={{
                          background: "#1e3c72",
                          color: "white",
                          width: "15%",
                        }}
                      >
                        Sr. No.
                      </th>
                      <th
                        style={{
                          background: "#1e3c72",
                          color: "white",
                          width: "60%",
                        }}
                      >
                        District
                      </th>
                      <th
                        style={{
                          background: "#1e3c72",
                          color: "white",
                          width: "25%",
                        }}
                      >
                        Count
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {districts.map((district, index) => (
                      <tr key={district.districtCode || district.districtName}>
                        <td style={{ color: "#495057" }}>{index + 1}</td>
                        <td style={{ color: "#1e3c72", fontWeight: 600 }}>
                          {district.districtName}
                        </td>
                        <td>
                          <span
                            style={{
                              background:
                                "linear-gradient(135deg, #16a085 0%, #27ae60 100%)",
                              color: "white",
                              fontSize: "14px",
                              fontWeight: 600,
                              borderRadius: "20px",
                              padding: "8px 20px",
                              display: "inline-block",
                            }}
                          >
                            {district.count}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            )}
          </CardBody>
        </Card>
      </Container>
    </>
  );
};

export default CapfRegistrationDistrictCounts;
